import Vue from "../main";
// import { products } from "../data/auctions.json"; // remove import if you are using an api
import { getProductsVariantService } from "../services/productService";

export async function addToWishlist(id) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  //try catch is optional, adapt to your own logic
  try {
    const [pId, vId] = id.split("-");
    // Make request for product
    const res = await getProductsVariantService({"prodottoId":pId});

    if (!res || res.error) {
      throw new Error(res.message || "Error while getting product details.");
    }

    var productVariant = res.varianti.find((v) => {
        return v._id == vId
    });

    // add to client-side wish list
    $store.dispatch("wishlist/addProduct", { [id]: productVariant});
    $toast.success(productVariant._prodotto?.[0]?.nome +" added to wishlist.");
  } catch {
    $toast.error("An error has occurred.");
    return "";
  }
}

export async function removeFromWishlist(id) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  //try catch is optional, adapt to your own logic
  try {
    const [pId, vId] = id.split("-");
    // Make request for product
    const res = await getProductsVariantService({"prodottoId":pId});

    if (!res || res.error) {
      throw new Error(res.message || "Error while getting product details.");
    }

    var productVariant = res.varianti.find((v) => {
        return v._id == vId
    });

    // add to client-side cart
    $store.dispatch("wishlist/removeProduct", id);
    $toast.success(productVariant._prodotto?.[0]?.nome +" removed from wishlist.");
  } catch {
    $toast.error("An error has occurred.");
    return "";
  }
}
